// @ts-nocheck
import React from "react";
import {ConfirmationButton} from "./ConfirmationButton";
import { Save as SaveIcon } from '@mui/icons-material';


export const SaveButton = ({type = "submit" ,onClose, label, disabled, onClick,...props}) => {
    let btnLabel = label? label : "Guardar";
    return (
        <ConfirmationButton
            type={type}
            onClose={onClose}
            startIcon={<SaveIcon />}
            props={props}
            disabled={disabled}
            onClick={onClick}
        >
            {btnLabel}
        </ConfirmationButton>
    );
};